export const cilWallet = ["24 24","<path d='M22.967 5.581c-0.203-0.204-0.483-0.331-0.794-0.331-0.001 0-0.002 0-0.003 0h-0.795v-1.875c-0.001-0.621-0.504-1.124-1.125-1.125h-16.189c0 0 0 0 0 0-1.828 0-3.311 1.482-3.311 3.311v0 12.879c0 1.828 1.482 3.311 3.311 3.311h18.066c0.62-0.001 1.122-0.502 1.125-1.121v-0l0.044-14.25c0-0.002 0-0.005 0-0.007 0-0.309-0.125-0.589-0.328-0.791l-0-0zM21.752 20.25h-17.692c-1 0-1.811-0.811-1.811-1.811v0-12.879c0-1 0.811-1.811 1.811-1.811h15.814v1.5h-15.75v1.5h17.669z'></path><path d='M18.375 12.375h1.5v1.5h-1.5v-1.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-wallet.js
// module id = null
// module chunks = 